export const validateDateOfBirth = (date: string): boolean => {
  const dateToValidate = new Date(date).getFullYear();
  const currentYear = new Date().getFullYear();
  const yearsOld = currentYear - dateToValidate;

  if (yearsOld < 18 || yearsOld >= 100) return false;

  return true;
};

export const validateDate = (date: string): boolean => {
  const dateToValidate = new Date(date).getFullYear();

  if (dateToValidate < 1900) return false;

  return true;
};
